<div class="dialog-header">
    <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<form style="width: 100%" [formGroup]="form" (ngSubmit)="submitForm()">
    <h3 style="text-align: center">Actualizar Datos</h3>
    <article class="form_purchase contenedor_update">
        <section class="container-form">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Tamaño</mat-label>
                <input matInput formControlName="companyCategory"/>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Nombre Empresa</mat-label>
                <input matInput formControlName="name"/>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Sitio Web</mat-label>
                <input matInput formControlName="website" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Nombre Contacto</mat-label>
                <input matInput formControlName="contactName" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Telefono</mat-label>
                <input matInput formControlName="phone" type="text" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Email</mat-label>
                <input type="text" matInput formControlName="email" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Direccion</mat-label>
                <input type="text" matInput formControlName="address" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-50">
                <mat-label>Número</mat-label>
                <input type="text" matInput formControlName="addressNumber"/>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-50">
                <mat-label>Oficina</mat-label>
                <input type="text" matInput formControlName="addressOffice"/>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Comuna</mat-label>
                <input type="text" matInput formControlName="commune" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Región</mat-label>
                <input type="text" matInput formControlName="region" />
            </mat-form-field>
        </section>
    </article>
    <section class="contenedor_boton">
        <button mat-flat-button color="primary" class="w-50" type="submit" [disabled]="this.form.invalid">
            Actualizar
        </button>
    </section>
</form>

<ng-template #loading>
    <mat-spinner [diameter]="40"></mat-spinner>
</ng-template>